/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface LanguageProficiencyRequest {
  languageCode: string;
  proficiencyId: number;
}
const LanguageProficiencyRequest = {
  create: (initValues?: Partial<LanguageProficiencyRequest> | null): LanguageProficiencyRequest => {
    const defaults: LanguageProficiencyRequest = {
      languageCode: "",
      proficiencyId: 0,
    };
    const fixedValues: Partial<LanguageProficiencyRequest> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default LanguageProficiencyRequest;
